import { render, staticRenderFns } from "./SurveyMultipleTextbox.vue?vue&type=template&id=8881ddd0&scoped=true"
import script from "./SurveyMultipleTextbox.vue?vue&type=script&lang=js"
export * from "./SurveyMultipleTextbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8881ddd0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3029718028/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8881ddd0')) {
      api.createRecord('8881ddd0', component.options)
    } else {
      api.reload('8881ddd0', component.options)
    }
    module.hot.accept("./SurveyMultipleTextbox.vue?vue&type=template&id=8881ddd0&scoped=true", function () {
      api.rerender('8881ddd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/survey-builder/components/SurveyMultipleTextbox.vue"
export default component.exports